/** Mirrors server RMA attachment rules (see rma-attachment-upload.middleware.js). */

export const RMA_ATTACHMENT_MAX_FILE_BYTES = 10 * 1024 * 1024;
export const RMA_ATTACHMENT_MAX_FILES = 10;

export const ALLOWED_RMA_ATTACHMENT_EXTENSIONS = new Set(['.pdf', '.jpg', '.jpeg', '.png']);
export const ALLOWED_RMA_ATTACHMENT_MIME_TYPES = new Set(['application/pdf', 'image/jpeg', 'image/png']);

export function isValidRmaAttachmentFile(selectedFile) {
    const fileName = selectedFile?.name || '';
    const extensionMatch = fileName.toLowerCase().match(/\.[^.]+$/);
    const fileExtension = extensionMatch?.[0] || '';
    const hasValidExtension = ALLOWED_RMA_ATTACHMENT_EXTENSIONS.has(fileExtension);
    const hasValidMimeType = ALLOWED_RMA_ATTACHMENT_MIME_TYPES.has(selectedFile.type);
    return hasValidExtension && hasValidMimeType;
}

export function rmaAttachmentFileTooLarge(selectedFile) {
    return typeof selectedFile?.size === 'number' && selectedFile.size > RMA_ATTACHMENT_MAX_FILE_BYTES;
}
